exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.newIcon[data-v-383f9cf4]{\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n            justify-content: center;\n}\n.ThisSpan[data-v-383f9cf4]{\r\n    text-align: center;\r\n    margin-top: 10px;\n}\n.ThisSpan-span[data-v-383f9cf4]{\r\n    color: #09bb07;\n}\n.bg-gray[data-v-383f9cf4] {\r\n    background: #eeeeee !important;\n}\n.newsteps-box[data-v-383f9cf4] {\r\n  background: #eeeeee !important;\n}\r\n", ""]);

// exports
